import { ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectPackageGoldCost } from "../../../balancingSelectors/selectBalancingPackages";
import { IdResource } from "../../../constants/IdResource";
import { selectFortuneTellerEventDetails } from "../../../selectors/selectFortuneTellerEventInfo";
import { selectPlayerInfo } from "../../../selectors/selectPlayerInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionInventoryInfoRemoveResource } from "../../info/inventory/actionInventoryInfo";
import { actionPurchasePackageInfoPurchased } from "../../info/purchase-packages/actionSetPurchasePackageInfo";
import { actionConsumePackage, } from "../../item-packages/actionPackages";
import { actionFortuneTellerEventRequest, TypeActionFortuneTellerEventInfo, } from "../actionFortuneTellerEventInfo";
export var epicFortuneTellerEventBuyPackageRequest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionFortuneTellerEventInfo.RequestBuyPackage), switchMap(function (action) {
        var state = state$.value;
        var playerId = selectPlayerInfo(state).playerId;
        var packageId = action.packageId;
        var eventDetails = selectFortuneTellerEventDetails(state);
        if (eventDetails && eventDetails[0] && eventDetails[0].eventId) {
            var eventId = eventDetails[0].eventId;
            return deps
                .netSend({
                id: CommandCode.BuyPackage,
                props: {
                    amount: 1,
                    eventId: eventId,
                    packageId: packageId,
                    playerId: playerId,
                },
            })
                .pipe(retry(), switchMap(function (res) {
                var cost = selectPackageGoldCost(packageId);
                var goldCost = { amount: cost, typeId: IdResource.Gold };
                return from([
                    actionConsumePackage(packageId),
                    actionInventoryInfoRemoveResource([goldCost]),
                    actionPurchasePackageInfoPurchased(packageId),
                    actionFortuneTellerEventRequest(),
                ]);
            }));
        }
        return EMPTY;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/epics/epicFortuneTellerEventBuyPackageRequest.ts
// module id = 1857
// module chunks = 3